import { CerteuropeSignMutationTypes } from './mutation_types'
import { CerteuropeSignState } from './state'
export const mutations: StoreMutations<CerteuropeSignMutationTypes, CerteuropeSignState> = {
  [CerteuropeSignMutationTypes.SET_SIGNING_VIEW_PENDING] (state, value) {
    state.signingViewPending = value
  },
  [CerteuropeSignMutationTypes.SET_SIGNING_VIEW] (state, value) {
    state.signingView = value
  },
  [CerteuropeSignMutationTypes.SET_SIGNING_VIEW_ERROR] (state, value) {
    state.signingViewError = value
  },
  [CerteuropeSignMutationTypes.SET_PAGES_ERROR] (state, value) {
    state.pagesError = value
  },
  [CerteuropeSignMutationTypes.ADD_PAGES_NUMBER_PENDING] (state, { fromPage, toPage }) {
    for (let i = fromPage; i <= toPage; i++) {
      const index = state.pagesNumberPending.findIndex(p => p === i)
      if (index < 0) {
        state.pagesNumberPending.push(i)
      }
    }
  },
  [CerteuropeSignMutationTypes.REMOVE_PAGES_NUMBER_PENDING] (state, { fromPage, toPage }) {
    for (let i = fromPage; i <= toPage; i++) {
      const index = state.pagesNumberPending.findIndex(p => p === i)
      if (index >= 0) {
        state.pagesNumberPending.splice(index, 1)
      }
    }
  },
  [CerteuropeSignMutationTypes.SET_PAGES] (state, value) {
    for (const newPage of value) {
      const pageExists = state.pages.some(page => page.id === newPage.id);
      if (!pageExists) {
        state.pages.push(newPage)
      }
    }
    state.pages.sort((a, b) => {
      return a.pageNumber - b.pageNumber
    })
  },
  [CerteuropeSignMutationTypes.SET_ACTIVE_PAGE] (state, pageNumber) {
    state.activePage = pageNumber
  },
  [CerteuropeSignMutationTypes.SET_SCROLL_TO] (state, pageNumber) {
    state.scrollTo = pageNumber
  },
  [CerteuropeSignMutationTypes.SET_SIGN_TAG_PENDING] (state, value) {
    state.signTagPendingIds.push(value)
  },
  [CerteuropeSignMutationTypes.REMOVE_SIGN_TAG_PENDING] (state, index) {
    state.signTagPendingIds.splice(index, 1)
  },
  [CerteuropeSignMutationTypes.SET_SIGN_TAG_ERROR] (state, value) {
    state.signTagError = value
  },
  [CerteuropeSignMutationTypes.SET_UNSIGN_TAG_PENDING] (state, value) {
    state.unsignTagPendingIds.push(value)
  },
  [CerteuropeSignMutationTypes.REMOVE_UNSIGN_TAG_PENDING] (state, index) {
    state.unsignTagPendingIds.splice(index, 1)
  },
  [CerteuropeSignMutationTypes.SET_UNSIGN_TAG_ERROR] (state, value) {
    state.unsignTagError = value
  },
  [CerteuropeSignMutationTypes.REFRESH_TAG] (state, payload) {
    const tagIndex = payload.page.tags.findIndex((el: { id: number }) => el.id === payload.tag.id)

    if (tagIndex >= 0) {
      payload.page.tags[tagIndex] = payload.tag
    }
  },
  [CerteuropeSignMutationTypes.SET_VALIDATION_MODAL_IS_OPEN] (state, value) {
    state.validationModalIsOpen = value
  },
  [CerteuropeSignMutationTypes.SET_SEND_VALIDATION_SMS_PENDING] (state, value) {
    state.sendValidationSmsPending = value
  },
  [CerteuropeSignMutationTypes.SET_SEND_VALIDATION_SMS_ERROR] (state, value) {
    state.sendValidationSmsError = value
  },
  [CerteuropeSignMutationTypes.SET_SIGN_DOCUMENT_PENDING] (state, value) {
    state.signDocumentPending = value
  },
  [CerteuropeSignMutationTypes.SET_SIGN_DOCUMENT_ERROR] (state, value) {
    state.signDocumentError = value
  },
  [CerteuropeSignMutationTypes.SET_RESEND_VALIDATION_SMS_PENDING] (state, value) {
    state.resendValidationSmsPending = value
  },
  [CerteuropeSignMutationTypes.SET_RESEND_VALIDATION_SMS_ERROR] (state, value) {
    state.resendValidationSmsError = value
  },
  [CerteuropeSignMutationTypes.SET_CONFIRM_SIGNATURE_PENDING] (state, value) {
    state.confirmSignaturePending = value
  },
  [CerteuropeSignMutationTypes.SET_CONFIRM_SIGNATURE_ERROR] (state, value) {
    state.confirmSignatureError = value
  },
  [CerteuropeSignMutationTypes.RESET] (state) {
    state.signingView = null
    state.pages = []
    state.activePage = null
    state.scrollTo = null
    state.validationModalIsOpen = false
  },
}
